import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, timeout: 15000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('apfx_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('apfx_token');
      localStorage.removeItem('apfx_user');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register: (email, password, name, referral_code) =>
    api.post('/auth/register', { email, password, name, referral_code: referral_code || null }).then(r => r.data),
  login: (email, password) => api.post('/auth/login', { email, password }).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
  googleSession: (session_id) => api.post('/auth/google/session', { session_id }).then(r => r.data),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }).then(r => r.data),
  resetPassword: (token, new_password) => api.post('/auth/reset-password', { token, new_password }).then(r => r.data)
};

export const positionsAPI = {
  list: () => api.get('/positions').then(r => r.data),
  open: (payload) => api.post('/positions', payload).then(r => r.data),
  update: (id, patch) => api.patch(`/positions/${id}`, patch).then(r => r.data),
  close: (id, close_price) => api.delete(`/positions/${id}`, { data: { close_price } }).then(r => r.data)
};

export const historyAPI = {
  list: (limit = 100) => api.get('/history', { params: { limit } }).then(r => r.data)
};

export const txAPI = {
  create: (payload) => api.post('/transactions', payload).then(r => r.data),
  list: (limit = 100) => api.get('/transactions', { params: { limit } }).then(r => r.data)
};

export const accountAPI = {
  summary: () => api.get('/account/summary').then(r => r.data)
};

export const analyticsAPI = {
  get: () => api.get('/analytics').then(r => r.data)
};

export const socialAPI = {
  leaderboard: () => api.get('/leaderboard').then(r => r.data),
  trader: (id) => api.get(`/traders/${id}`).then(r => r.data),
  follow: (id) => api.post(`/follow/${id}`).then(r => r.data),
  unfollow: (id) => api.delete(`/follow/${id}`).then(r => r.data),
  following: () => api.get('/following').then(r => r.data),
  copyLast: (id) => api.post(`/copy/${id}`).then(r => r.data)
};

export const newsAPI = {
  latest: (limit = 40, category = 'all') => api.get('/news', { params: { limit, category } }).then(r => r.data),
  finnhub: (category = 'general', limit = 40) => api.get('/finnhub/news', { params: { category, limit } }).then(r => r.data),
  companyNews: (symbol, limit = 20) => api.get(`/finnhub/company-news/${symbol}`, { params: { limit } }).then(r => r.data)
};

export const alertsAPI = {
  list: () => api.get('/alerts').then(r => r.data),
  create: (payload) => api.post('/alerts', payload).then(r => r.data),
  delete: (id) => api.delete(`/alerts/${id}`).then(r => r.data),
  trigger: (id) => api.post(`/alerts/${id}/trigger`).then(r => r.data)
};

export const withdrawMethodsAPI = {
  list: () => api.get('/withdraw-methods').then(r => r.data),
  add: (payload) => api.post('/withdraw-methods', payload).then(r => r.data),
  remove: (id) => api.delete(`/withdraw-methods/${id}`).then(r => r.data)
};

export const kycAPI = {
  me: () => api.get('/kyc/me').then(r => r.data),
  submit: (payload) => api.post('/kyc/submit', payload, { timeout: 60000 }).then(r => r.data)
};

export const notificationsAPI = {
  list: () => api.get('/notifications').then(r => r.data),
  unreadCount: () => api.get('/notifications/unread_count').then(r => r.data),
  markRead: (id) => api.post(`/notifications/${id}/read`).then(r => r.data),
  markAllRead: () => api.post('/notifications/read_all').then(r => r.data),
  remove: (id) => api.delete(`/notifications/${id}`).then(r => r.data)
};

export const referralAPI = {
  me: () => api.get('/referral/me').then(r => r.data),
  attach: (code) => api.post('/referral/attach', { code }).then(r => r.data)
};

export const depositAccountsAPI = {
  listActive: () => api.get('/deposit-accounts').then(r => r.data)
};
